import { Box, IconButton, makeStyles, Step, StepLabel, Stepper, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import CustomButton from '../../components/CustomButton'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData } from '../../lib/RestApi/customApiHandler'
import CustomHeading from '../../components/CustomHeading'
import DealerForm from './DealerForm'
import Layout from '../../components/Layout'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import {ROUTES} from '../../shared/constants'
import { Close } from '@material-ui/icons'
import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
import { useFeatures } from '../../hooks/Features/useFeatures'
import useDebounce from '../../hooks/useDebounce'
import { useDealer } from '../../hooks/Features/useDealer'
import { useHistory } from 'react-router'
import {useParams} from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: '4px',
    margin  : '10px',
    color: 'white',
    fontWeight: '600',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      // padding: '0px 178px',
      width: '20%',
      marginTop: '35px',
      //   marginLeft: '20px',
    },
  },
  iconContainer: {
    color: 'white',
    fontSize: '27px',
  },
  stepContent: {
    // marginTop: '15px',
  },
  heading: { fontWeight: 'bold', textAlign: 'center', marginBottom: '15px' },
}))

function getSteps() {
  return ['Info', 'Business Info', 'Location','Documents', '2nd Authorized Person']
}

export default function AddDealer({}) {
  const {id}= useParams()
  const classes = useStyles()
 
  const { addDealerLevel, dealer, getOneDealer } = useDealer();

  React.useEffect(()=>{
    console.log({id}, {dealer})
    if(!dealer && id!== undefined){
      getOneDealer(id);
    }
    console.log({dealer})
  }, [dealer])

  React.useEffect(()=>{
    if(dealer){
      setDealer1({dealerId: dealer?._id, name: dealer?.name,  countryCode: dealer?.countryCode, phone: dealer?.phone, address: dealer?.address, email:dealer?.email })
      setDealer2({dealerId: dealer?._id, businessName: dealer? dealer.businessName:"",  businessCategory: dealer? dealer.businessCategory: '', businessAddress: dealer? dealer.businesssAddress: '', type:dealer? dealer.type:'' , gst: dealer? dealer.gst: ''})
      setDealer3({dealerId: dealer?._id, accountName: dealer? dealer.accountName: '',  accountNumber: dealer? dealer.accountNumber: '', branchName: dealer? dealer.branchName: '', ifsc:dealer? dealer.ifsc: '' })
      setDealer4({dealerId: dealer?._id, signature: dealer? dealer.signature: '',  bankStatement: dealer? dealer.bankStatement: '', firmIdProof: dealer? dealer.firmIdProof: '', businessLegalProof: dealer? dealer.businessLegalProof: '', idProof: dealer? dealer.idProof?.idProof: '', idProofFront: dealer? dealer.idProof?.front:'', idProofBack: dealer? dealer.idProof?.back: '', addressProof : dealer? dealer.addressProof?.addressProof: '',  addressProofFront: dealer? dealer.addressProof?.front:'', addressProofBack: dealer? dealer.addressProof?.back: '' })
      setDealer5({dealerId: dealer?._id, signature: dealer? dealer.secondAuthorizedPerson?.signature: '', boardResolution: dealer? dealer.secondAuthorizedPerson?.boardResolution: '', idProof: dealer? dealer.secondAuthorizedPerson?.idProof?.idProof: '', addressProof : dealer? dealer.secondAuthorizedPerson?.addressProof?.addressProof: '', addressProofFront : dealer? dealer.secondAuthorizedPerson?.addressProof?.front: '', addressProofBack : dealer? dealer.secondAuthorizedPerson?.addressProof?.back: '', idProofFront : dealer? dealer.secondAuthorizedPerson?.idProof?.front: '', idProofBack : dealer? dealer.secondAuthorizedPerson?.idProof?.back: '' })
    }
  }, [dealer])
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce(searchQuery, 500)
  const [dealer1, setDealer1] = React.useState({dealerId: dealer?._id, name: dealer?.name,  countryCode: dealer?.countryCode, phone: dealer?.phone, address: dealer?.address, email:dealer?.email })
  const [dealer2, setDealer2] = React.useState({dealerId: dealer?._id, businessName: dealer? dealer.businessName:"",  businessCategory: dealer? dealer.businessCategory: '', businessAddress: dealer? dealer.businesssAddress: '', type:dealer? dealer.type:'' , gst: dealer? dealer.gst: ''})
  const [dealer3, setDealer3] = React.useState({dealerId: dealer?._id, accountName: dealer? dealer.accountName: '',  accountNumber: dealer? dealer.accountNumber: '', branchName: dealer? dealer.branchName: '', ifsc:dealer? dealer.ifsc: '' })
  const [dealer4, setDealer4] = React.useState({dealerId: dealer?._id, signature: dealer? dealer.signature: '',  bankStatement: dealer? dealer.bankStatement: '', firmIdProof: dealer? dealer.firmIdProof: '', businessLegalProof: dealer? dealer.businessLegalProof: '', idProof: dealer? dealer.idProof?.idProof: '', idProofFront: dealer? dealer.idProof?.front:'', idProofBack: dealer? dealer.idProof?.back: '', addressProof : dealer? dealer.addressProof?.addressProof: '',  addressProofFront: dealer? dealer.addressProof?.front:'', addressProofBack: dealer? dealer.addressProof?.back: '' })
  const [dealer5, setDealer5] =  React.useState({dealerId: dealer?._id, signature: dealer? dealer.secondAuthorizedPerson?.signature: '', boardResolution: dealer? dealer.secondAuthorizedPerson?.boardResolution: '', idProof: dealer? dealer.secondAuthorizedPerson?.idProof?.idProof: '', addressProof : dealer? dealer.secondAuthorizedPerson?.addressProof?.addressProof: '', addressProofFront : dealer? dealer.secondAuthorizedPerson?.addressProof?.front: '', addressProofBack : dealer? dealer.secondAuthorizedPerson?.addressProof?.back: '', idProofFront : dealer? dealer.secondAuthorizedPerson?.idProof?.front: '', idProofBack : dealer? dealer.secondAuthorizedPerson?.idProof?.back: '' })
  const [step, setStep] = React.useState(0);

  let { data: businessCategory, isLoading } = useQuery(['business-category', debouncedValue && debouncedValue], () => getAllData('/business-category', { searchQuery: debouncedValue }))
  let { data: idProofs, isLoading2 } = useQuery(['id-proofs', ], () => getAllData('/id-proof', {}))
  const inputStep1 = [
    {
      label: 'Name',
      value: dealer1.name,
      name: 'name',
    },
    {
      label: 'email',
      value: dealer1.email,
      name: 'email',
      conditions: [{ type: 'EMAIL' }]
    },
    {
      label: 'address',
      value: dealer1.address,
      name: 'address',
    },
    {
      label: 'countryCode',
      value: dealer1.countryCode,
      name: 'countryCode',
      type: 'COUNTRYCODE',
    },
    {
      label: 'phone',
      value: dealer1.phone,
      name: 'phone',
    },
  ]

  const inputStep2 = [
    {
      label: 'BusinessName',
      value: dealer2.businessName,
      name: 'businessName',
    },
    {
      label: 'Business Category',
      value: dealer2.businessCategory,
      name: 'businessCategory',
      options: businessCategory? businessCategory.data: [],
      fieldValue: '_id',
      fieldName: 'name'
    },
    {
      label: 'type',
      value: dealer2.type,
      name: 'type',
    },
    {
      label: 'business address',
      value: dealer2.businessAddress,
      name: 'businessAddress',
    },
    {
      label: 'GST Number',
      value: dealer2.gst,
      name: 'gst',
    },
  ]

  const inputStep3 = [
 
    {
      label: 'account holder name',
      value: dealer3.accountName,
      name: 'accountName',
    },
    {
      label: 'Account Number',
      value: dealer3.accountNumber,
      name: 'accountNumber',
    },
    {
      label: 'Bank Name',
      value: dealer3.branchName,
      name: 'branchName',
    },
    {
      label: 'ifsc code',
      value: dealer3.ifsc,
      name: 'ifsc',
    },
  ]

  const inputStep4 = [
    {
      label: 'Id Proof',
      value: dealer4.idProof,
      name: 'idProof',
      options: idProofs? idProofs.data: [],
      fieldValue: '_id',
      fieldName: 'name'
    },
    {
      label: 'Id Proof Front',
      value: dealer4.idProofFront,
      name: 'idProofFront',
      type: 'IMAGE',
      s3upload: true,      
    },
    {
      label: 'Id Proof Back',
      value: dealer4.idProofBack,
      name: 'idProofBack',
      type: 'IMAGE',
      s3upload: true,
    },
    {
      label: 'Address Proof',
      value: dealer4.addressProof,
      name: 'addressProof',
      options: idProofs? idProofs.data: [],
      fieldValue: '_id',
      fieldName: 'name',
    },
    {
      label: 'Address Proof Front',
      value: dealer4.addressProofFront,
      name: 'addressProofFront',
      type: 'IMAGE',
      s3upload: true,
    },
    {
      label: 'Address Proof Back',
      value: dealer4.addressProofBack,
      name: 'addressProofBack',
      type: 'IMAGE',
      s3upload: true,      
    },
    {
      label: 'address',
      value: dealer4.address,
      name: 'address',
    },
    {
      label: 'phone',
      value: dealer4.phone,
      name: 'phone',
    },
  ]

  const inputStep5 = [
    {
      label: 'Id Proof',
      value: dealer5.idProof,
      name: 'idProof',
      options: idProofs? idProofs.data: [],
      fieldValue: '_id',
      fieldName: 'name'
    },
    {
      label: 'Id Proof Front',
      value: dealer5.idProofFront,
      name: 'idProofFront',
      type: 'IMAGE',
      s3upload: true,
    },
    {
      label: 'Id Proof Back',
      value: dealer5.idProofBack,
      name: 'idProofBack',
      type: 'IMAGE',
      s3upload: true,
    },
    {
      label: 'Address Proof',
      value: dealer5.addressProof,
      name: 'addressProof',
      options: idProofs? idProofs.data: [],
      fieldValue: '_id',
      fieldName: 'name',
    },
    {
      label: 'Address Proof Front',
      value: dealer5.addressProofFront,
      name: 'addressProofFront',
      type: 'IMAGE',
      s3upload: true,
    
    },
    {
      label: 'Address Proof Back',
      value: dealer5.addressProofBack,
      name: 'addressProofBack',
      type: 'IMAGE',
      s3upload: true,      
    },
    {
      label: 'signature',
      value: dealer5.signature,
      name: 'signature',
    },
    {
      label: 'Board Resolution',
      value: dealer5.boardResolution,
      name: 'boardResolution',
      type: 'IMAGE',
      s3upload: true, 
    },
  ]

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <DealerForm handleClose= {()=>{}} input = {inputStep1} state = {dealer1} setState ={setDealer1} level = {1} handleSubmit = {()=>{}} handleNext = {handleNext} />
      case 1:
        return <DealerForm handleClose= {()=>{}} input = {inputStep2} state = {dealer2} setState ={setDealer2} level = {2} handleSubmit = {()=>{}} handleNext = {handleNext} />
      case 2:
        return <DealerForm handleClose= {()=>{}} input = {inputStep3} state = {dealer3} setState ={setDealer3} level = {3} handleSubmit = {()=>{}} handleNext = {handleNext} />
      case 3:
        return <DealerForm handleClose= {()=>{}} input = {inputStep4} state = {dealer4} setState ={setDealer4} level = {4} handleSubmit = {()=>{}} handleNext = {handleNext} />
      case 4:
        return <DealerForm handleClose= {()=>{}} input = {inputStep5} state = {dealer5} setState ={setDealer5} level = {5} handleSubmit = {()=>{}} handleNext = {handleNext} />
      default:
        return 'Unknown step'
    }
  }
  const steps = getSteps()

  const handleClose = ()=>{
    return "Heloo"
  }

  const handleNext = ()=>{setStep(step=>{ return step+1}) }

  const addDealer = (step, data) => {
    console.log("adding dealer", step)
    console.log(data);
    console.log(dealer);
    addDealerLevel(step, (dealer ? {dealerId: dealer?._id } : false), data);
    step!== 5 ? handleNext(): history.push("/dealer-onboarding-requests");
  }
  const getDealer = (level)=>{
    switch(level){
      case 1:
        return dealer1
      case 2: 
        return dealer2
      case 3:
        return dealer3
      case 4: 
        return {
          ...dealer4, 
          idProof: {
            idProof: dealer4?.idProof,
            front: dealer4?.idProofFront.length? dealer4?.idProofFront[0]: dealer4?.idProofFront,
            back: dealer4?.idProofBack.length? dealer4?.idProofBack[0]: dealer4?.idProofBack,
          },
          addressProof: {
            addressProof: dealer4?.addressProof,
            front: dealer4?.addressProofFront.length? dealer4?.addressProofFront[0]: dealer4?.addressProofFront,
            back: dealer4?.addressProofBack.length? dealer4?.addressProofBack[0]: dealer4?.addressProofBack,
          },
      }
      case 5: 
        return {...dealer5,
        secondAuthorizedPerson: {
          idProof: {
            idProof: dealer5?.idProof,
            front: dealer5?.idProofFront.length? dealer5?.idProofFront[0]: dealer5?.idProofFront,
            back: dealer5?.idProofBack.length? dealer5?.idProofBack[0]: dealer5?.idProofBack,
          },
          addressProof: {
            addressProof: dealer5?.addressProof,
            front: dealer5?.addressProofFront.length? dealer5?.addressProofFront[0]: dealer5?.addressProofFront,
            back: dealer5?.addressProofBack.length? dealer5?.addressProofBack[0]: dealer5?.addressProofBack,
          },
          signature: dealer5.signature,
          boardResolution: dealer5?.boardResolution.length? dealer5?.boardResolution[0]: dealer5?.boardResolution
        }}
      default: 
      return dealer1

    }
  }

  
 return (
    <div>
      <Layout heading={`Dealer Onboarding`} heading2={` ${dealer!== undefined ? 'Edit' : 'Add'}`} url1={ROUTES.DEALER_ONBOARDING} none>
      <HeaderTabLayout
        heading={`${dealer !== undefined ? 'Edit' : 'Add'}  Dealer `}
        state = {dealer1}
        setState = {setDealer1}
        content={
          <>
          {/* <Box display="flex" justifyContent="space-between">
            <IconButton color="inherit" onClick={handleClose}>
              <Close />
            // </IconButton>
          </Box> */}
          <Stepper activeStep={step} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            {/* {step === steps.length ? (
              <>{(handleClose(), setStep(0))}</>
            ) : ( */}
              <div className={classes.stepContent}>
                {getStepContent(step)}
                <Box display="flex" justifyContent="space-between">
                {step!==0 && <CustomButton
                    handleSubmit={()=>{setStep(step-1)}}
                    text={ `Back to step ${step}`}
                    className={classes.button}
                  />}
                  <CustomButton
                    handleSubmit={()=>{addDealer(step+1,  getDealer(step+1))}}
                    text={step === steps.length - 1 ? 'Submit' : `Continue to step ${step + 2}`}
                    className={classes.button}
                  />
                   
                </Box>
              </div>
            {/* )} */}
          </div>
      </>
        }
        addContent={addDealer}
        text={`${dealer!== undefined ? 'Update' : 'Add'}`}
        redirect={ROUTES.BEAT_PLANS}
        loading={false}
        view = {true}
      />
    </Layout>
      
    </div>
  )
}
